<div class="ui-g guest-profile-container" *ngIf="technicianApplication && !submitted">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <h4 class="margin-header-align">{{ 'basic-profile.fields.base_data' | translate }}</h4>
    <hr />
  </div>

  <div
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align"
    *ngIf="technicianApplication && technicianApplication.status && technicianApplication.status === userStatus['REVOKED']">
    <h4 class="margin-header-align rejection-message text-message-align">{{ technicianApplication['reasonDescription'] }}</h4>
  </div>

  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-12 form-column" [formGroup]="companyDataFG">
    <div class="ui-g-12 margin-align">
      <label for="float-input-steuer" class="ui-g-5">{{ 'basic-profile.fields.tax_id' | translate }}</label>
      <input
        id="float-input-steuer"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="tax_id"
        (change)="getCompanyDetails()" />
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-unternehmen" class="ui-g-5 required">{{ 'basic-profile.fields.company' | translate }}</label>
      <input
        id="float-input-unternehmen"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="company_name" />
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-strabe" class="ui-g-5 required">{{ 'basic-profile.fields.street' | translate }}</label>
      <input
        id="float-input-strabe"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="street" />
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-hausenummer" class="ui-g-5 required">{{ 'basic-profile.fields.street_number' | translate }}</label>
      <input
        id="float-input-hausenummer"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="street_number" />
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-plz" class="ui-g-5 required">{{ 'basic-profile.fields.postcode' | translate }}</label>
      <input
        id="float-input-plz"
        type="text"
        size="30"
        pInputText
        [appNumber]="true"
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="postcode" />
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-ort" class="ui-g-5 required">{{ 'basic-profile.fields.city' | translate }}</label>
      <input
        id="float-input-ort"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="city" />
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-telephone" class="ui-g-5 required">{{ 'basic-profile.fields.telephone_central' | translate }}</label>
      <input
        id="float-input-telephone"
        [appNumber]="true"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="telephone" />
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-inhaber" class="ui-g-5 required">{{ 'basic-profile.fields.ceo' | translate }}</label>
      <input
        id="float-input-inhaber"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="ceo" />
    </div>

    <div class="ui-g-12 margin-align flex" *ngIf="showBaseDataEmail">
      <label for="float-input-email" class="ui-g-5 required">{{ 'basic-profile.fields.mail' | translate }}</label>
      <input
        id="float-input-email"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="email"
        disabled />
      <div class="ui-g-1">
        <i
          class="pi pi-info-circle hint-icon"
          tooltipStyleClass="netz-info-tooltip"
          pTooltip="{{ 'basic-profile.fields.emailInfo' | translate }}"></i>
      </div>
    </div>

    <div class="ui-g-12 margin-align">
      <label class="ui-g-4"></label>
      <p-radioButton
        name="group"
        value="hauptbetrieb"
        [label]="'basic-profile.fields.headoffice' | translate"
        labelStyleClass="required"
        formControlName="headsubsidiary"></p-radioButton>
    </div>
    <div class="ui-g-12 margin-align">
      <label class="ui-g-4"></label>
      <p-radioButton
        name="group"
        value="nebenbetrieb"
        [label]="'basic-profile.fields.subsidiary' | translate"
        labelStyleClass="required"
        formControlName="headsubsidiary"></p-radioButton>
    </div>
    <div class="ui-g-12 margin-align" *ngIf="showMainBusinessesPartTimeRadioBtn">
      <label class="ui-g-4"></label>
      <p-radioButton
        name="group"
        value="main_businesses_part_time"
        [label]="'basic-profile.fields.main_businesses_part_time' | translate"
        labelStyleClass="required"
        formControlName="headsubsidiary"></p-radioButton>
    </div>
    <div class="ui-g-12 margin-align" *ngIf="showAuxiliaryOption">
      <label class="ui-g-4"></label>
      <p-radioButton
        name="group"
        value="auxiliary_company"
        [label]="'basic-profile.fields.auxiliary' | translate"
        labelStyleClass="required"
        formControlName="headsubsidiary"></p-radioButton>
    </div>
  </div>

  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-12 form-column" [formGroup]="technicianDataFG">
    <div class="ui-g-12 margin-align">
      <label for="float-input-anrede" class="ui-g-5 required">{{ 'basic-profile.fields.title' | translate }}</label>

      <p-dropdown [options]="allTitles" formControlName="sk_title" id="float-input-anrede" placeholder="-Select-">
        <ng-template let-item pTemplate="selectedItem">
          <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + item['value'] + '.name' | translate }}</span>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <div class="drop-item">
            <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + option['value'] + '.name' | translate }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-varName" class="ui-g-5 required">{{ 'basic-profile.fields.first_name_installer' | translate }}</label>
      <input
        id="float-input-varName"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="first_name" />
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-nachName" class="ui-g-5 required">{{ 'basic-profile.fields.last_name_installer' | translate }}</label>
      <input
        id="float-input-nachName"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="last_name" />
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-geburtsdatum" class="ui-g-5 required">{{ 'basic-profile.fields.birthday' | translate }}</label>
      <p-calendar
        tabIndex="0"
        appCalendarEscapeClose
        id="float-input-geburtsdatum"
        formControlName="birthday"
        [dateFormat]="dateFormat.dateFormat"
        [placeholder]="dateFormat.placeholder"
        [locale]="'app.calendar-settings' | translate"
        [monthNavigator]="true"
        [yearNavigator]="true"
        yearRange="1900:2080"></p-calendar>
    </div>

    <div class="ui-g-12 margin-align">
      <label for="float-input-telefon" class="ui-g-5 required">{{ 'basic-profile.fields.telephone_mobile_number' | translate }}</label>
      <input
        id="float-input-telefon"
        [appNumber]="true"
        size="30"
        pInputText
        maxlength="50"
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="telephone" />
    </div>

    <div class="ui-g-12 margin-align" *ngIf="showMandatoryDocument">
      <label for="float-input-masters-examination" class="ui-g-5 required">
        {{ 'basic-profile.fields.masters_examination' | translate }}
      </label>
      <p-dropdown [options]="options" id="float-input-masters-examination" formControlName="qualification_type">
        <ng-template let-item pTemplate="selectedItem">
          <span class="drop-item-label">{{ 'app.drop_down.' + item['label'] | translate }}</span>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <div class="drop-item">
            <span class="drop-item-label">{{ 'app.drop_down.' + option['label'] | translate }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="ui-g-12 margin-align flex">
      <label for="float-input-technician-email" class="ui-g-5 required">{{ 'basic-profile.fields.mail' | translate }}</label>
      <input
        id="float-input-technician-email"
        type="text"
        size="30"
        pInputText
        class="h4-button-and-field ui-input pInputText filed-width"
        formControlName="email"
        disabled />
      <div class="ui-g-1">
        <i
          class="pi pi-info-circle hint-icon"
          tooltipStyleClass="netz-info-tooltip"
          pTooltip="{{ 'basic-profile.fields.emailInfo' | translate }}"></i>
      </div>
    </div>
  </div>

  <!--Api attributes is required to save data in backend-->
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
    <h4 class="margin-header-align text-uppercase">{{ 'overview.details-data.section-titles.network-permissions' | translate }}</h4>
    <hr />
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" [formGroup]="checkDataFG">
    <div *ngFor="let object of items; let i = index">
      <div class="ui-g-3 margin-align">
        <p-checkbox
          appEnterClick
          id="details-checkbox-{{ i }}"
          [formControlName]="object.field"
          binary="true"
          label="{{ 'overview.details-data.data-rows.' + object.field | translate }}"
          [disabled]="isReadOnly"></p-checkbox>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" *ngIf="enabledRadioButtons()">
      <div class="ui-g-3 margin-align">
        <p-radioButton
          name="license"
          value="withLicense"
          [label]="'basic-profile.fields.with_welding_license' | translate"
          formControlName="license"
          [disabled]="isReadOnly"></p-radioButton>
      </div>
      <div class="ui-g-3 margin-align">
        <p-radioButton
          name="license"
          value="withoutLicense"
          [label]="'basic-profile.fields.with_out_welding_license' | translate"
          formControlName="license"
          [disabled]="isReadOnly"></p-radioButton>
      </div>
    </div>
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" *ngIf="enabledFileUpload()">
      <app-file
        [documents]="documents"
        [fileType]="'welding_certificate_confirmation'"
        (fileEvent)="fileEvent()"
        [isRequired]="true"
        [taId]="taId"
        [isReadonly]="isReadOnly"></app-file>
    </div>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
    <h4 class="margin-header-align text-uppercase">{{ 'basic-profile.fields.take_mandatory_documents' | translate }}</h4>
    <hr />
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
    <app-file
      [documents]="documents"
      [fileType]="'id_card_main_fraud'"
      (fileEvent)="fileEvent()"
      [isRequired]="isIdCardRequired"
      [taId]="taId"
      [isReadonly]="isReadOnly"></app-file>
  </div>

  <div *ngIf="showMandatoryDocument" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
      <h4 class="margin-header-align text-uppercase">{{ 'basic-profile.fields.mandatory_documents' | translate }}</h4>
      <hr />
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" *ngIf="getFileEnabled('proof_of_qualification')">
      <app-file [documents]="documents" [fileType]="'proof_of_qualification'" (fileEvent)="fileEvent()" [taId]="taId"></app-file>
    </div>
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" *ngIf="showOneDayTrainingTrgiBasedOnSelection">
      <app-file
        [documents]="documents"
        [fileType]="'one_day_training_trgi_2018'"
        [isRequired]="mandatoryDocumentsForGuest.has('one_day_training_trgi_2018')"
        (fileEvent)="fileEvent()"
        [taId]="taId"
        [isReadonly]="isReadOnly"></app-file>
    </div>
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" *ngIf="showOneDayTrainingTrwiBasedOnSelection">
      <app-file
        [documents]="documents"
        [fileType]="'one_day_training_trwi'"
        [isRequired]="mandatoryDocumentsForGuest.has('one_day_training_trgi_2018')"
        (fileEvent)="fileEvent()"
        [taId]="taId"
        [isReadonly]="isReadOnly"></app-file>
    </div>
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" *ngIf="showOneDayTrainingTrwi2012">
      <app-file
        [documents]="documents"
        [fileType]="'one_day_training_trwi_2012'"
        (fileEvent)="fileEvent()"
        [taId]="taId"
        [isReadonly]="isReadOnly"></app-file>
    </div>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
    <app-nested-file [taId]="taId" [documents]="documents" (fileEvent)="fileEvent()" [isReadonly]="isReadOnly"></app-nested-file>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column submit-margin margin-top-align">
    <!--<div class="ui-g-5 text-align">
        <h5>{{'basic-profile.fields.policy-left' | translate}}</h5>
    </div>
    <div class="ui-g-5 text-align">
        <h5>{{'basic-profile.fields.policy-right' | translate}}</h5>
    </div>-->
    <div *ngIf="!isReadOnly" class="ui-g-12 margin-align text-center">
      <button
        pButton
        type="button"
        icon="pi pi-check"
        iconPos="left"
        (click)="saveForm()"
        [disabled]="guestProfileFormValidity()"
        [label]="'basic-profile.jurisdiction.proceed' | translate"></button>
    </div>
  </div>
</div>
<div class="ui-g" *ngIf="submitted">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <h4
      class="margin-header-align text-message-align"
      *ngIf="
        (technicianApplication && technicianApplication.status && technicianApplication.status === concessionStatus.submitted) ||
        technicianApplication.status === concessionStatus.renew_requested
      ">
      {{ 'basic-profile.fields.application-pending-text' | translate }}
    </h4>
    <h4
      class="margin-header-align text-message-align"
      *ngIf="technicianApplication && technicianApplication.status && technicianApplication.status === concessionStatus.granted">
      {{ 'basic-profile.fields.application-granted-text' | translate }}
    </h4>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
